// To do local development (npm start), copy this file to firebase.local.js 
// and update with your config. This will overwrite staging and production
// setting.
module.exports = {
  apiKey: "AIzaSyAY-1S19ZPQhLDkEw8FvFrOwPOWYFI5WaQ",
  authDomain: "selim-test-harken.firebaseapp.com",
  projectId: "selim-test-harken",
  storageBucket: "selim-test-harken.firebasestorage.app",
  messagingSenderId: "437403621114",
  appId: "1:437403621114:web:39184c6e268c297abb5b43"
};
